
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/loyalty-card",
      function () {
        return require("private-next-pages/loyalty-card.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/loyalty-card"])
      });
    }
  